import { MouseEvent, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'

import styles from './DropDown.module.scss'
import classNames from 'classnames'

const DropDown = () => {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (e: MouseEvent<HTMLAnchorElement>, to: string) => {
    if (location.pathname === to) {
      e.preventDefault()
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.head} onClick={() => setIsOpen(!isOpen)}>
        <p>Past events</p>
        <ArrowIcon />
      </div>
      <div className={classNames(styles.body, { [styles.body_active]: isOpen })}>
        <NavLink
          to='/events/2024'
          rel='noopener noreferrer'
          target='_blank'
          className={({ isActive }) => classNames(styles.body__item, { [styles.body__item_active]: isActive })}
          onClick={e => handleClick(e, '/events/2024')}
        >
          2024
        </NavLink>
      </div>
    </div>
  )
}

export default DropDown
